var MITSUBISHI_SG10A = {
  name: "MITSUBISHI_SG10A",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,255,254,114,73,249,62,127,63,255,255,255,255,255,255,249,159,20,158,114,103,38,78,115,255,255,255,231,36,159,147,231,243,255,255,255,255,255,255,255,153,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,255,249,51,231,255,255,255,255,255,255,254,124,197,39,156,153,201,147,156,255,255,249,249,255,255,228,207,159,255,255,255,255,255,255,249,243,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,255,254,76,243,255,255,255,255,255,255,255,39,241,73,231,38,114,100,231,63,255,254,126,124,255,254,76,243,255,255,255,255,255,255,255,39,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,127,254,76,243,255,255,255,255,255,255,255,207,197,39,156,153,201,147,156,255,255,249,249,249,255,249,51,207,255,255,255,255,255,255,255,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,159,255,147,60,255,255,255,255,255,255,255,204,252,82,121,201,156,153,57,207,255,255,159,159,39,255,228,207,63,255,255,255,255,255,255,243,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,63,254,76,243,255,255,255,255,255,255,255,147,241,73,231,38,114,100,231,63,255,254,126,127,63,254,76,243,255,255,255,255,255,255,255,147,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,207,255,147,60,255,255,255,255,255,255,255,201,63,20,158,114,103,38,78,115,255,255,231,231,204,255,249,51,207,255,255,255,255,255,255,252,147,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,79,255,147,60,255,255,255,255,255,255,255,249,241,73,231,38,114,100,231,63,255,254,126,126,79,255,147,60,255,255,255,255,255,255,255,249,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,147,255,228,207,63,255,255,255,255,255,255,243,159,20,158,114,103,38,78,115,255,255,231,231,201,63,254,76,243,255,255,255,255,255,255,255,57,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,159,254,76,243,255,255,255,255,255,255,255,153,241,73,231,38,114,100,231,63,255,254,126,127,159,254,76,243,255,255,255,255,255,255,255,153,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,231,255,147,60,255,255,255,255,255,255,255,201,159,20,158,114,103,38,78,115,255,255,231,231,206,127,249,51,207,255,255,255,255,255,255,252,153,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,103,255,147,60,255,255,255,255,255,255,255,242,124,82,121,201,156,153,57,207,255,255,159,159,153,255,228,207,63,255,255,255,255,255,255,252,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,153,255,228,207,63,255,255,255,255,255,255,243,39,197,39,156,153,201,147,156,255,255,249,249,242,103,255,147,60,255,255,255,255,255,255,255,204,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,39,255,147,60,255,255,255,255,255,255,255,228,159,20,158,114,103,38,78,115,255,255,231,231,242,127,249,51,207,255,255,255,255,255,255,254,73,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,201,255,228,207,63,255,255,255,255,255,255,242,73,241,73,231,38,114,100,231,63,255,254,126,124,201,255,228,207,63,255,255,255,255,255,255,242,73,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,73,255,228,207,63,255,255,255,255,255,255,255,60,82,121,201,156,153,57,207,255,255,159,159,146,127,249,51,207,255,255,255,255,255,255,255,207,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,146,127,249,51,231,255,255,255,255,255,255,252,243,49,73,231,38,114,100,231,63,255,254,126,124,146,127,249,51,231,255,255,255,255,255,255,252,243,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,255,249,159,159,255,255,255,255,255,255,242,73,39,20,158,114,103,38,78,115,255,255,231,231,255,255,153,249,255,255,255,255,255,255,255,36,146,112,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,255,254,103,207,255,255,255,255,255,255,255,252,82,121,201,156,153,57,207,255,255,159,159,63,255,153,243,255,255,255,255,255,255,255,255,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,127,254,103,207,255,255,255,255,255,255,252,255,20,158,114,103,38,78,115,255,255,231,231,231,255,230,124,255,255,255,255,255,255,255,207,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,159,255,153,243,255,255,255,255,255,255,255,159,197,39,156,153,201,147,156,255,255,249,249,242,127,254,103,207,255,255,255,255,255,255,254,127,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,63,254,103,207,255,255,255,255,255,255,252,159,197,39,156,153,201,147,156,255,255,249,249,252,255,249,159,63,255,255,255,255,255,255,242,127,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,207,255,153,243,255,255,255,255,255,255,255,207,197,39,156,153,201,147,156,255,255,249,249,243,63,254,103,207,255,255,255,255,255,255,255,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,79,255,153,243,255,255,255,255,255,255,255,51,241,73,231,38,114,100,231,63,255,254,126,126,79,255,153,243,255,255,255,255,255,255,255,51,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,147,255,230,124,255,255,255,255,255,255,255,228,252,82,121,201,156,153,57,207,255,255,159,159,36,255,249,159,63,255,255,255,255,255,255,249,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,159,254,103,207,255,255,255,255,255,255,252,147,241,73,231,38,114,100,231,63,255,254,126,127,159,254,103,207,255,255,255,255,255,255,252,147,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,231,255,153,243,255,255,255,255,255,255,255,231,197,39,156,153,201,147,156,255,255,249,249,243,159,254,103,207,255,255,255,255,255,255,255,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,103,255,153,243,255,255,255,255,255,255,255,57,241,73,231,38,114,100,231,63,255,254,126,126,103,255,153,243,255,255,255,255,255,255,255,57,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,153,255,230,124,255,255,255,255,255,255,255,230,124,82,121,201,156,153,57,207,255,255,159,159,38,127,249,159,63,255,255,255,255,255,255,249,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,127,39,255,153,243,255,255,255,255,255,255,255,38,124,82,121,201,156,153,57,207,255,255,159,159,201,255,230,124,255,255,255,255,255,255,255,201,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,201,255,230,124,255,255,255,255,255,255,255,242,124,82,121,201,156,153,57,207,255,255,159,159,50,127,249,159,63,255,255,255,255,255,255,252,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,126,73,255,230,124,255,255,255,255,255,255,255,204,159,20,158,114,103,38,78,115,255,255,231,231,228,159,254,103,207,255,255,255,255,255,255,252,201,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,126,124,146,127,249,159,159,255,255,255,255,255,255,249,39,49,73,231,38,114,100,231,63,255,254,126,124,146,127,249,159,159,255,255,255,255,255,255,249,39,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,127,255,249,207,159,255,255,255,255,255,255,243,243,20,158,114,103,38,78,115,255,255,231,231,255,255,156,249,255,255,255,255,255,255,255,63,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,255,254,115,207,255,255,255,255,255,255,254,127,20,158,114,103,38,78,115,255,255,231,231,207,255,231,60,255,255,255,255,255,255,255,231,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,126,127,254,115,207,255,255,255,255,255,255,252,159,197,39,156,153,201,147,156,255,255,249,249,249,255,249,207,63,255,255,255,255,255,255,242,127,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,159,255,156,243,255,255,255,255,255,255,255,207,197,39,156,153,201,147,156,255,255,249,249,242,127,254,115,207,255,255,255,255,255,255,255,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,127,63,254,115,207,255,255,255,255,255,255,252,207,197,39,156,153,201,147,156,255,255,249,249,252,255,249,207,63,255,255,255,255,255,255,243,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,207,255,156,243,255,255,255,255,255,255,255,147,241,73,231,38,114,100,231,63,255,254,126,124,207,255,156,243,255,255,255,255,255,255,255,147,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,126,79,255,156,243,255,255,255,255,255,255,255,36,252,82,121,201,156,153,57,207,255,255,159,159,147,255,231,60,255,255,255,255,255,255,255,201,63,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,147,255,231,60,255,255,255,255,255,255,255,249,241,73,231,38,114,100,231,63,255,254,126,124,147,255,231,60,255,255,255,255,255,255,255,249,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,127,159,254,115,207,255,255,255,255,255,255,252,231,197,39,156,153,201,147,156,255,255,249,249,254,127,249,207,63,255,255,255,255,255,255,243,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,231,255,156,243,255,255,255,255,255,255,255,153,241,73,231,38,114,100,231,63,255,254,126,124,231,255,156,243,255,255,255,255,255,255,255,153,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,126,103,255,156,243,255,255,255,255,255,255,255,38,124,82,121,201,156,153,57,207,255,255,159,159,153,255,231,60,255,255,255,255,255,255,255,201,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,100,201,206,127,255,252,252,249,51,255,206,121,255,255,255,255,255,255,255,228,248,164,243,147,57,50,115,159,255,255,63,62,76,255,243,158,127,255,255,255,255,255,255,249,62,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,127,39,255,156,243,255,255,255,255,255,255,255,50,124,82,121,201,156,153,57,207,255,255,159,159,201,255,231,60,255,255,255,255,255,255,255,204,159,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,201,255,231,60,255,255,255,255,255,255,255,228,159,20,158,114,103,38,78,115,255,255,231,231,204,159,254,115,207,255,255,255,255,255,255,254,73,240,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,43,221,110,181,221,255,255,247,239,213,255,238,247,255,255,255,255,255,255,254,171,226,87,186,221,107,187,255,255,239,223,171,255,221,239,255,255,255,255,255,255,253,87,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,124,146,127,249,207,159,255,255,255,255,255,255,255,51,20,158,114,103,38,78,115,255,255,231,231,201,39,255,156,249,255,255,255,255,255,255,255,243,48,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,255,147,228,207,159,255,255,255,255,255,255,254,76,197,39,156,153,201,147,156,255,255,249,249,63,254,79,147,62,127,255,255,255,255,255,255,249,51,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,63,228,249,51,207,255,255,255,255,255,255,252,228,241,73,231,38,114,100,231,63,255,254,126,79,63,228,249,51,207,255,255,255,255,255,255,252,228,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,159,228,249,51,207,255,255,255,255,255,255,254,100,241,73,231,38,114,100,231,63,255,254,126,79,159,228,249,51,207,255,255,255,255,255,255,254,100,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,39,249,62,76,243,255,255,255,255,255,255,255,38,79,20,158,114,103,38,78,115,255,255,231,228,242,127,147,228,207,63,255,255,255,255,255,255,242,100,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,207,228,249,51,207,255,255,255,255,255,255,255,36,241,73,231,38,114,100,231,63,255,254,126,79,207,228,249,51,207,255,255,255,255,255,255,255,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,51,249,62,76,243,255,255,255,255,255,255,255,50,79,20,158,114,103,38,78,115,255,255,231,228,243,63,147,228,207,63,255,255,255,255,255,255,243,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,79,228,201,255,63,255,255,255,255,255,255,243,204,145,73,231,38,114,100,231,63,255,254,127,158,79,228,201,255,63,255,255,255,255,255,255,243,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,147,249,50,127,207,255,255,255,255,255,255,254,115,36,82,121,201,156,153,57,207,255,255,159,231,36,254,76,159,243,255,255,255,255,255,255,255,156,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,159,147,39,252,255,255,255,255,255,255,255,201,204,145,73,231,38,114,100,231,63,255,254,127,159,159,147,39,252,255,255,255,255,255,255,255,201,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,231,228,201,255,63,255,255,255,255,255,255,252,204,145,73,231,38,114,100,231,63,255,254,127,156,231,228,201,255,63,255,255,255,255,255,255,252,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,103,228,201,255,63,255,255,255,255,255,255,243,51,36,82,121,201,156,153,57,207,255,255,159,231,153,249,50,127,207,255,255,255,255,255,255,252,204,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,153,249,50,127,207,255,255,255,255,255,255,254,76,201,20,158,114,103,38,78,115,255,255,231,249,201,159,147,39,252,255,255,255,255,255,255,255,228,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,39,228,201,255,63,255,255,255,255,255,255,242,76,201,20,158,114,103,38,78,115,255,255,231,249,242,126,76,159,243,255,255,255,255,255,255,255,36,204,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,201,249,50,127,207,255,255,255,255,255,255,255,147,36,82,121,201,156,153,57,207,255,255,159,231,50,126,76,159,243,255,255,255,255,255,255,255,228,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,73,249,50,127,207,255,255,255,255,255,255,252,228,201,20,158,114,103,38,78,115,255,255,231,249,228,159,147,39,252,255,255,255,255,255,255,255,206,76,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,146,126,76,159,249,255,255,255,255,255,255,255,153,60,82,121,201,156,153,57,207,255,255,159,231,36,159,147,39,254,127,255,255,255,255,255,255,230,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,255,147,230,126,127,255,255,255,255,255,255,204,204,197,39,156,153,201,147,156,255,255,249,249,63,254,79,153,249,255,255,255,255,255,255,255,51,51,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,252,252,158,127,201,243,62,127,255,255,255,255,255,255,242,103,138,79,57,51,147,39,57,255,255,243,242,121,255,39,204,249,255,255,255,255,255,255,255,201,158,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,43,221,110,181,221,255,255,247,235,239,245,246,251,255,255,255,255,255,255,255,86,241,43,221,110,181,221,255,255,247,235,239,245,246,251,255,255,255,255,255,255,255,86,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,39,249,62,103,207,255,255,255,255,255,255,255,147,197,39,156,153,201,147,156,255,255,249,249,60,159,228,249,159,63,255,255,255,255,255,255,254,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,207,228,249,159,63,255,255,255,255,255,255,243,147,197,39,156,153,201,147,156,255,255,249,249,63,63,147,230,124,255,255,255,255,255,255,255,206,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,43,221,110,181,221,255,255,247,235,219,250,251,125,255,255,255,255,255,255,255,218,241,43,221,110,181,221,255,255,247,235,219,250,251,125,255,255,255,255,255,255,255,218,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,147,249,62,103,207,255,255,255,255,255,255,252,153,60,82,121,201,156,153,57,207,255,255,159,147,228,254,79,153,243,255,255,255,255,255,255,255,38,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,36,254,79,153,243,255,255,255,255,255,255,255,201,60,82,121,201,156,153,57,207,255,255,159,147,201,63,147,230,124,255,255,255,255,255,255,255,242,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,231,228,249,159,63,255,255,255,255,255,255,243,36,241,73,231,38,114,100,231,63,255,254,126,79,231,228,249,159,63,255,255,255,255,255,255,243,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,57,249,62,103,207,255,255,255,255,255,255,254,73,60,82,121,201,156,153,57,207,255,255,159,147,206,126,79,153,243,255,255,255,255,255,255,255,146,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,153,249,62,103,207,255,255,255,255,255,255,252,146,79,20,158,114,103,38,78,115,255,255,231,228,249,159,147,230,124,255,255,255,255,255,255,255,201,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,38,126,79,153,243,255,255,255,255,255,255,255,249,197,39,156,153,201,147,156,255,255,249,249,60,153,249,62,103,207,255,255,255,255,255,255,255,231,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,201,249,62,103,207,255,255,255,255,255,255,252,249,197,39,156,153,201,147,156,255,255,249,249,63,39,228,249,159,63,255,255,255,255,255,255,243,231,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,50,126,79,153,243,255,255,255,255,255,255,255,158,113,73,231,38,114,100,231,63,255,254,126,79,50,126,79,153,243,255,255,255,255,255,255,255,158,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,43,221,110,181,221,255,255,247,235,234,253,125,190,255,255,255,255,255,255,255,215,184,149,238,183,90,238,255,255,251,245,245,126,190,223,127,255,255,255,255,255,255,235,220,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,36,159,147,230,126,127,255,255,255,255,255,255,243,147,20,158,114,103,38,78,115,255,255,231,228,242,73,249,62,103,231,255,255,255,255,255,255,255,57,48,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,255,147,231,62,127,255,255,255,255,255,255,201,51,49,73,231,38,114,100,231,63,255,254,126,79,255,147,231,62,127,255,255,255,255,255,255,201,51,48,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,63,228,249,207,63,255,255,255,255,255,255,254,79,20,158,114,103,38,78,115,255,255,231,228,243,254,79,156,243,255,255,255,255,255,255,255,228,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,159,228,249,207,63,255,255,255,255,255,255,243,147,197,39,156,153,201,147,156,255,255,249,249,62,127,147,231,60,255,255,255,255,255,255,255,206,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,39,249,62,115,207,255,255,255,255,255,255,254,100,241,73,231,38,114,100,231,63,255,254,126,79,39,249,62,115,207,255,255,255,255,255,255,254,100,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,207,228,249,207,63,255,255,255,255,255,255,242,100,241,73,231,38,114,100,231,63,255,254,126,79,207,228,249,207,63,255,255,255,255,255,255,242,100,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,51,249,62,115,207,255,255,255,255,255,255,255,36,241,73,231,38,114,100,231,63,255,254,126,79,51,249,62,115,207,255,255,255,255,255,255,255,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,147,249,62,115,207,255,255,255,255,255,255,252,201,60,82,121,201,156,153,57,207,255,255,159,147,228,254,79,156,243,255,255,255,255,255,255,255,50,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,36,254,79,156,243,255,255,255,255,255,255,255,146,79,20,158,114,103,38,78,115,255,255,231,228,242,79,228,249,207,63,255,255,255,255,255,255,249,36,240,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,231,228,249,207,63,255,255,255,255,255,255,242,73,60,82,121,201,156,153,57,207,255,255,159,147,249,249,62,115,207,255,255,255,255,255,255,252,146,79,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,57,249,62,115,207,255,255,255,255,255,255,255,231,20,158,114,103,38,78,115,255,255,231,228,243,159,147,231,60,255,255,255,255,255,255,255,254,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,153,249,62,115,207,255,255,255,255,255,255,252,249,197,39,156,153,201,147,156,255,255,249,249,62,103,228,249,207,63,255,255,255,255,255,255,243,231,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,38,126,79,156,243,255,255,255,255,255,255,255,158,113,73,231,38,114,100,231,63,255,254,126,79,38,126,79,156,243,255,255,255,255,255,255,255,158,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,201,249,62,115,207,255,255,255,255,255,255,252,158,113,73,231,38,114,100,231,63,255,254,126,79,201,249,62,115,207,255,255,255,255,255,255,252,158,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,50,126,79,156,243,255,255,255,255,255,255,255,206,113,73,231,38,114,100,231,63,255,254,126,79,50,126,79,156,243,255,255,255,255,255,255,255,206,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,146,126,79,156,243,255,255,255,255,255,255,255,51,156,82,121,201,156,153,57,207,255,255,159,147,228,159,147,231,60,255,255,255,255,255,255,255,204,231,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,126,79,36,159,147,231,62,127,255,255,255,255,255,255,228,228,197,39,156,153,201,147,156,255,255,249,249,60,146,126,79,156,249,255,255,255,255,255,255,255,147,147,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,254,79,147,62,127,255,255,255,255,255,255,254,76,82,121,201,156,153,57,207,255,255,159,231,255,147,228,207,159,255,255,255,255,255,255,255,147,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,255,147,228,207,63,255,255,255,255,255,255,243,231,20,158,114,103,38,78,115,255,255,231,249,207,249,62,76,243,255,255,255,255,255,255,255,62,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,127,147,228,207,63,255,255,255,255,255,255,249,231,20,158,114,103,38,78,115,255,255,231,249,231,249,62,76,243,255,255,255,255,255,255,255,158,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,159,228,249,51,207,255,255,255,255,255,255,252,158,113,73,231,38,114,100,231,63,255,254,127,156,159,228,249,51,207,255,255,255,255,255,255,252,158,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,63,147,228,207,63,255,255,255,255,255,255,252,231,20,158,114,103,38,78,115,255,255,231,249,243,249,62,76,243,255,255,255,255,255,255,255,206,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,207,228,249,51,207,255,255,255,255,255,255,252,206,113,73,231,38,114,100,231,63,255,254,127,156,207,228,249,51,207,255,255,255,255,255,255,252,206,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,79,228,249,51,207,255,255,255,255,255,255,254,78,113,73,231,38,114,100,231,63,255,254,127,158,79,228,249,51,207,255,255,255,255,255,255,254,78,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,147,249,62,76,243,255,255,255,255,255,255,255,36,231,20,158,114,103,38,78,115,255,255,231,249,201,63,147,228,207,63,255,255,255,255,255,255,242,78,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,159,147,228,207,63,255,255,255,255,255,255,254,103,20,158,114,103,38,78,115,255,255,231,249,249,249,62,76,243,255,255,255,255,255,255,255,230,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,231,228,249,51,207,255,255,255,255,255,255,252,230,113,73,231,38,114,100,231,63,255,254,127,156,231,228,249,51,207,255,255,255,255,255,255,252,230,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,103,228,249,51,207,255,255,255,255,255,255,254,102,113,73,231,38,114,100,231,63,255,254,127,158,103,228,249,51,207,255,255,255,255,255,255,254,102,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,153,249,62,76,243,255,255,255,255,255,255,255,38,103,20,158,114,103,38,78,115,255,255,231,249,201,159,147,228,207,63,255,255,255,255,255,255,242,102,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,39,228,249,51,207,255,255,255,255,255,255,255,38,113,73,231,38,114,100,231,63,255,254,127,159,39,228,249,51,207,255,255,255,255,255,255,255,38,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,201,249,62,76,243,255,255,255,255,255,255,255,50,103,20,158,114,103,38,78,115,255,255,231,249,204,159,147,228,207,63,255,255,255,255,255,255,243,38,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,73,249,62,76,243,255,255,255,255,255,255,255,146,103,20,158,114,103,38,78,115,255,255,231,249,228,159,147,228,207,63,255,255,255,255,255,255,249,38,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,146,126,79,147,62,127,255,255,255,255,255,255,201,38,76,82,121,201,156,153,57,207,255,255,159,231,36,159,147,228,207,159,255,255,255,255,255,255,242,73,147,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,254,79,153,249,255,255,255,255,255,255,255,50,76,197,39,156,153,201,147,156,255,255,249,254,127,249,62,103,231,255,255,255,255,255,255,252,201,51,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,255,147,230,124,255,255,255,255,255,255,255,228,147,197,39,156,153,201,147,156,255,255,249,254,115,254,79,153,243,255,255,255,255,255,255,255,146,79,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,127,147,230,124,255,255,255,255,255,255,255,201,36,241,73,231,38,114,100,231,63,255,254,127,158,127,147,230,124,255,255,255,255,255,255,255,201,36,240,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,159,228,249,159,63,255,255,255,255,255,255,255,156,82,121,201,156,153,57,207,255,255,159,231,39,249,62,103,207,255,255,255,255,255,255,255,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,63,147,230,124,255,255,255,255,255,255,255,207,156,82,121,201,156,153,57,207,255,255,159,231,207,228,249,159,63,255,255,255,255,255,255,243,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,207,228,249,159,63,255,255,255,255,255,255,249,231,20,158,114,103,38,78,115,255,255,231,249,204,254,79,153,243,255,255,255,255,255,255,255,158,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,79,228,249,159,63,255,255,255,255,255,255,242,121,197,39,156,153,201,147,156,255,255,249,254,121,63,147,230,124,255,255,255,255,255,255,255,201,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,147,249,62,103,207,255,255,255,255,255,255,255,57,197,39,156,153,201,147,156,255,255,249,254,114,79,228,249,159,63,255,255,255,255,255,255,252,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,159,147,230,124,255,255,255,255,255,255,255,204,231,20,158,114,103,38,78,115,255,255,231,249,249,249,62,103,207,255,255,255,255,255,255,252,206,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,231,228,249,159,63,255,255,255,255,255,255,249,57,197,39,156,153,201,147,156,255,255,249,254,115,159,147,230,124,255,255,255,255,255,255,255,228,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,103,228,249,159,63,255,255,255,255,255,255,242,78,113,73,231,38,114,100,231,63,255,254,127,158,103,228,249,159,63,255,255,255,255,255,255,242,78,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,153,249,62,103,207,255,255,255,255,255,255,255,153,197,39,156,153,201,147,156,255,255,249,254,114,103,228,249,159,63,255,255,255,255,255,255,254,103,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,39,228,249,159,63,255,255,255,255,255,255,243,153,197,39,156,153,201,147,156,255,255,249,254,124,159,147,230,124,255,255,255,255,255,255,255,206,103,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,201,249,62,103,207,255,255,255,255,255,255,254,102,113,73,231,38,114,100,231,63,255,254,127,156,201,249,62,103,207,255,255,255,255,255,255,254,102,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,73,249,62,103,207,255,255,255,255,255,255,252,153,156,82,121,201,156,153,57,207,255,255,159,231,146,126,79,153,243,255,255,255,255,255,255,255,38,103,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,146,126,79,153,249,255,255,255,255,255,255,255,201,147,20,158,114,103,38,78,115,255,255,231,249,201,39,228,249,159,159,255,255,255,255,255,255,252,153,48,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,254,79,156,249,255,255,255,255,255,255,255,36,147,49,73,231,38,114,100,231,63,255,254,127,159,254,79,156,249,255,255,255,255,255,255,255,36,147,48,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,255,147,231,60,255,255,255,255,255,255,255,254,113,73,231,38,114,100,231,63,255,254,127,156,255,147,231,60,255,255,255,255,255,255,255,254,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,127,147,231,60,255,255,255,255,255,255,255,207,156,82,121,201,156,153,57,207,255,255,159,231,159,228,249,207,63,255,255,255,255,255,255,243,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,159,228,249,207,63,255,255,255,255,255,255,249,231,20,158,114,103,38,78,115,255,255,231,249,201,254,79,156,243,255,255,255,255,255,255,255,158,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,63,147,231,60,255,255,255,255,255,255,255,201,231,20,158,114,103,38,78,115,255,255,231,249,243,249,62,115,207,255,255,255,255,255,255,252,158,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,207,228,249,207,63,255,255,255,255,255,255,252,231,20,158,114,103,38,78,115,255,255,231,249,204,254,79,156,243,255,255,255,255,255,255,255,206,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,79,228,249,207,63,255,255,255,255,255,255,243,57,197,39,156,153,201,147,156,255,255,249,254,121,63,147,231,60,255,255,255,255,255,255,255,204,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,147,249,62,115,207,255,255,255,255,255,255,254,78,113,73,231,38,114,100,231,63,255,254,127,156,147,249,62,115,207,255,255,255,255,255,255,254,78,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,159,147,231,60,255,255,255,255,255,255,255,201,57,197,39,156,153,201,147,156,255,255,249,254,126,126,79,156,243,255,255,255,255,255,255,255,36,231,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,231,228,249,207,63,255,255,255,255,255,255,254,103,20,158,114,103,38,78,115,255,255,231,249,206,126,79,156,243,255,255,255,255,255,255,255,230,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,103,228,249,207,63,255,255,255,255,255,255,243,153,197,39,156,153,201,147,156,255,255,249,254,121,159,147,231,60,255,255,255,255,255,255,255,206,103,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,153,249,62,115,207,255,255,255,255,255,255,254,102,113,73,231,38,114,100,231,63,255,254,127,156,153,249,62,115,207,255,255,255,255,255,255,254,102,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,159,39,228,249,207,63,255,255,255,255,255,255,242,102,113,73,231,38,114,100,231,63,255,254,127,159,39,228,249,207,63,255,255,255,255,255,255,242,102,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,201,249,62,115,207,255,255,255,255,255,255,255,38,113,73,231,38,114,100,231,63,255,254,127,156,201,249,62,115,207,255,255,255,255,255,255,255,38,112,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,158,73,249,62,115,207,255,255,255,255,255,255,252,201,156,82,121,201,156,153,57,207,255,255,159,231,146,126,79,156,243,255,255,255,255,255,255,255,50,103,8],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,73,231,38,114,100,231,63,255,254,127,156,146,126,79,156,249,255,255,255,255,255,255,255,146,100,197,39,156,153,201,147,156,255,255,249,254,114,73,249,62,115,231,255,255,255,255,255,255,254,73,147,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,127,63,159,159,147,60,255,255,255,255,255,255,255,243,60,82,121,201,156,153,57,207,255,255,159,207,231,231,228,207,63,255,255,255,255,255,255,252,207,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  73,231,38,114,100,231,63,255,254,127,63,159,159,153,243,255,255,255,255,255,255,255,60,241,73,231,38,114,100,231,63,255,254,127,63,159,159,153,243,255,255,255,255,255,255,255,60,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [71,2,5,  130,1, 195,1,  165,11, 190,6,  130,1, 0,5,  130,1, 2,44,  130,1, 0,0,  43,221,110,181,221,255,255,247,247,247,239,221,239,255,255,255,255,255,255,253,119,137,94,235,117,174,239,255,255,191,191,191,126,239,127,255,255,255,255,255,255,235,188,32],
    },
    ]
};

export default MITSUBISHI_SG10A
